let stripeJsPromise = null;

/**
 * Load Stripe.js v3 from js.stripe.com (Stripe requires loading from their
 * domain, so this is injected at runtime instead of bundled) and resolve
 * with the global Stripe constructor.
 */
export function loadStripeJs() {
  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }

  if (stripeJsPromise) {
    return stripeJsPromise;
  }

  stripeJsPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.onload = () => {
      if (window.Stripe) {
        resolve(window.Stripe);
        return;
      }

      stripeJsPromise = null;
      reject(new Error('Stripe.js loaded but window.Stripe is missing'));
    };
    script.onerror = () => {
      stripeJsPromise = null;
      reject(new Error('Failed to load Stripe.js'));
    };
    document.head.appendChild(script);
  });

  return stripeJsPromise;
}
